import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { QuickReplyState } from '../../types'

export const updateQuickReplyAction = createAsyncAction(
  '@chat/UPDATE_QUICK_REPLY_REQUEST',
  '@chat/UPDATE_QUICK_REPLY_SUCCESS',
  '@chat/UPDATE_QUICK_REPLY_FAILURE'
)<Request, Success, Failure>()

const request = (
  state: QuickReplyState,
  action: ActionType<typeof updateQuickReplyAction.request>
): QuickReplyState => ({
  ...state,
  isLoadingUpdateQuickReply: true
})

const success = (
  state: QuickReplyState,
  action: ActionType<typeof updateQuickReplyAction.success>
): QuickReplyState => {
  return {
    ...state,
    isLoadingUpdateQuickReply: false,
    isSuccessOnUpdateQuickReply: true
  }
}

const failure = (
  state: QuickReplyState,
  action: ActionType<typeof updateQuickReplyAction.failure>
): QuickReplyState => ({
  ...state,
  isLoadingUpdateQuickReply: false,
  isErrorOnUpdateQuickReply: true
})

export const updateQuickReplyHandle = { asyncAction: updateQuickReplyAction, request, success, failure }
